import { ChainPath } from '../types';

export enum EBlockchainFeature {
  ComingSoon = 'coming soon',
  GRPC = 'grpc',
  GRPC_WEB = 'grpc-web',
  REST = 'rest',
  RPC = 'rpc',
  WS = 'ws',
}

export enum EBlockchainType {
  Mainnet = 'mainnet',
  Extension = 'extension',
  Testnet = 'testnet',
  Devnet = 'devnet',
  Customized = 'customized',
  Beacon = 'beacon',
  Opnode = 'opnode',
  Signet = 'signet',
  Vrpc = 'vrpc',
}

export interface IBlockchainEntity {
  id: string;
  coinName: string;
  name: string;
  premiumOnly?: boolean;
  isPublic?: boolean;
  type: EBlockchainType;

  extends?: string;
  features: EBlockchainFeature[];
  paths?: ChainPath[];
}

export interface BlockchainUrls {
  blockchain: IBlockchainEntity;
  enterpriseURLs: string[];
  enterpriseWsURLs: string[];
  grpcURLs: string[];
  restURLs: string[];
  rpcURLs: string[];
  wsURLs: string[];
}

type ChainId = string;

export type ChainsConfig = Record<ChainId, BlockchainUrls>;
